<div class="d-none d-lg-flex flex-row flex-wrap flex-100 icons">
  <div class="flex-100">
    <button *ngIf="productSimple?.isInStock" [attr.aria-label]="'Cart'" mat-raised-button color="primary" matTooltip="Add to cart" matTooltipPosition="left" (click)="addToCart(productSimple)" class="button-text">
      <mat-icon class="ml-0 mr-1">shopping_cart</mat-icon><span class="button-text">Add To Cart</span>
    </button>
    <button *ngIf="!productSimple?.isInStock" [attr.aria-label]="'Cart'" mat-raised-button color="accent" matTooltip="Temporarily out of Stock" matTooltipPosition="left" (click)="outOfStock(productSimple)" class="button-text">
      <mat-icon class="ml-0 mr-1">remove_shopping_cart</mat-icon><span class="button-text">Back Soon</span>
    </button>
  </div>
</div>
<div class="d-lg-none icons">
  <button *ngIf="productSimple?.isInStock" [attr.aria-label]="'Cart'" mat-raised-button color="primary" matTooltip="Add to cart" matTooltipPosition="above" (click)="addToCart(productSimple)">
    <mat-icon class="ml-0 mr-0">add_shopping_cart</mat-icon>
  </button>
  <button *ngIf="!productSimple?.isInStock" [attr.aria-label]="'Cart'" mat-raised-button color="accent" matTooltip="Temporarily out of Stock" matTooltipPosition="above" (click)="outOfStock(productSimple)">
    <mat-icon class="ml-0 mr-0">remove_shopping_cart</mat-icon>
  </button>
</div>
